/* BS24 Vertrauen – Neufassung 29.09.2026
   Liest die Live-Werte (Bewertungsanzahl, Prozent) aus dem unsichtbaren
   Trustami-Widget und aktualisiert Anzeige und JSON-LD. Die Texte kommen
   als Vorlagen aus der Section (data-pa, data-cl), gepflegt in
   snippets/bs24-vertrauen-texte.liquid. */
(function(){
  'use strict';

  var D = window.BS24V_DATA;
  var root = document.querySelector('.bs24v');
  if(!D || !root) return;

  /* Zahlen-/Datumsformat nach Shop-Sprache (wie bisher: 1.026.423 / 98,90).
     Nur Englisch richtet sich zusaetzlich nach dem Land: en-GB 26/09/2026,
     en-US 09/26/2026. data-lang = Sprache-Land, z. B. en-GB. */
  var tag = root.getAttribute('data-lang') || document.documentElement.lang || 'de';
  var lang = tag.split('-')[0].toLowerCase();
  if(lang === 'nb') lang = 'no';
  if(lang === 'en' && /^en-[A-Z]{2}$/i.test(tag)){
    try{ new Intl.NumberFormat(tag); lang = tag; }catch(e){}
  }

  function el(id){ return document.getElementById(id); }
  function num(n){ try{ return n.toLocaleString(lang); }catch(e){ return String(n); } }
  function pct(p){ try{ return p.toLocaleString(lang, {minimumFractionDigits:2, maximumFractionDigits:2}); }catch(e){ return String(p); } }
  function datum(iso){
    try{ return new Date(iso + 'T00:00:00').toLocaleDateString(lang, {day:'2-digit', month:'2-digit', year:'numeric'}); }
    catch(e){ return iso; }
  }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function zeichnen(){
    if(el('bs24v-n-positive')) el('bs24v-n-positive').textContent = pct(D.positive) + ' %';

    var pa = root.getAttribute('data-pa');
    if(pa && el('bs24v-count')) el('bs24v-count').textContent = pa.replace('%V', num(D.reviews));

    var cl = root.getAttribute('data-cl');
    if(cl && el('bs24v-claim')){
      var t = cl.replace('%D', datum(D.stand)).replace('%O', num(D.orders)).replace('%C', num(D.countries))
                .replace('%V', num(D.reviews)).replace('%P', pct(D.positive));
      t = t.replace(/(\d) %/g, '$1\u00a0%'); /* Zahl und % nicht trennen */
      el('bs24v-claim').innerHTML = esc(t).replace(/\[\[/g, '<strong>').replace(/\]\]/g, '</strong>');
    }

    var j = el('bs24v-jsonld');
    if(j){
      try{
        var o = JSON.parse(j.textContent);
        o.aggregateRating.ratingValue = D.positive;
        o.aggregateRating.reviewCount = D.reviews;
        j.textContent = JSON.stringify(o);
      }catch(e){}
    }
  }

  /* Live-Werte aus dem Trustami-Rahmen (about:blank = gleicher Ursprung) */
  function trustamiLesen(){
    var box = root.querySelector('.widget_container_stars_badge');
    if(!box) return false;
    var f = box.querySelector('iframe');
    if(!f) return false;
    var doc;
    try{ doc = f.contentDocument; }catch(e){ return false; }
    if(!doc || !doc.body) return false;
    var t = (doc.body.innerText || doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    if(!t) return false;

    var m = t.match(/([0-9][0-9.,]*)\s*Review/i);
    var p = t.match(/([0-9]+[.,][0-9]+)\s*%/);
    var geaendert = false;

    if(m){
      var r = parseInt(m[1].replace(/[.,\s]/g, ''), 10);
      if(r > 0 && r !== D.reviews){ D.reviews = r; geaendert = true; }
    }
    if(p){
      var v = parseFloat(p[1].replace(',', '.'));
      if(v > 0 && v <= 100 && v !== D.positive){ D.positive = v; geaendert = true; }
    }
    if(geaendert || m) zeichnen();
    return !!m;
  }

  function start(){
    zeichnen();
    var versuche = 0;
    var timer = setInterval(function(){
      versuche++;
      if(trustamiLesen() || versuche > 40) clearInterval(timer);
    }, 500);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
